import { ROUTE_NAMES } from '@/constant/routes'

export const SCREEN_LOAD_EVENT_NAME = 'Screen Load Time'
export const EDITOR_ROUTE_NAMES = [ROUTE_NAMES.PRESENTATION_DETAIL, ROUTE_NAMES.PPT_ADDIN_EDIT_SLIDES]
export const MAX_REPORTED_DURATION_MS = 10 * 60 * 1000

const SCREEN_EDITOR = 'editor'
const SCREEN_PRESENTER = 'presenter'

export const readNavigationType = (performanceRef) => {
  const entry = performanceRef?.getEntriesByType?.('navigation')?.[0]
  return entry?.type || 'navigate'
}

export const isEditorRoute = (routeName) => EDITOR_ROUTE_NAMES.includes(routeName)

export const createScreenLoadTimer = ({
  now, getPageLoadType, getDeviceInfo, isHidden, track, afterNextPaint,
}) => {
  let pending = null
  let finishingModeSwitch = false

  const isReady = (snapshot) => (
    snapshot.presentationId != null &&
    String(snapshot.presentationId) === String(snapshot.routePresentationId) &&
    snapshot.slideCount > 0 &&
    Boolean(snapshot.activeSlideId)
  )

  const emit = (screen, snapshot) => {
    const durationMs = Math.round(now() - pending.startMs)
    const { type } = pending
    pending = null
    finishingModeSwitch = false
    if (durationMs < 0 || durationMs > MAX_REPORTED_DURATION_MS) return
    track(SCREEN_LOAD_EVENT_NAME, {
      screen,
      durationMs,
      navigationType: type,
      slideCount: snapshot.slideCount,
      presentationId: snapshot.presentationId,
      routeName: snapshot.routeName,
      tabHiddenAtReady: Boolean(isHidden()),
      ...getDeviceInfo(),
    })
  }

  const markNavigationStart = (to, from) => {
    if (!isEditorRoute(to?.name)) {
      pending = null
      finishingModeSwitch = false
      return
    }
    const isSameRoutePresentation = to.name === from?.name && String(to.params?.id) === String(from?.params?.id)
    if (isSameRoutePresentation) return
    const isFirstNavigation = !from?.name
    finishingModeSwitch = false
    pending = isFirstNavigation
      ? { startMs: 0, type: getPageLoadType() }
      : { startMs: now(), type: 'spa' }
  }

  const markPresentStart = () => {
    if (pending && pending.type !== 'mode_switch') return
    finishingModeSwitch = false
    pending = { startMs: now(), type: 'mode_switch' }
  }

  const evaluate = (snapshot) => {
    if (!isEditorRoute(snapshot.routeName)) {
      pending = null
      finishingModeSwitch = false
      return
    }
    if (!pending || !isReady(snapshot)) return
    const screen = snapshot.isPresenting ? SCREEN_PRESENTER : SCREEN_EDITOR
    if (pending.type !== 'mode_switch') {
      emit(screen, snapshot)
      return
    }
    if (!snapshot.isPresenting || finishingModeSwitch) return
    finishingModeSwitch = true
    const span = pending
    afterNextPaint(() => {
      if (pending === span) emit(SCREEN_PRESENTER, snapshot)
    })
  }

  return { markNavigationStart, markPresentStart, evaluate }
}
